/** Scan prep instructions — copy aligned with ref-landing-page/steps.html */

export const ADHOC_INSTRUCTIONS_TITLE = "You're in. Let's get your reading.";

export const ADHOC_INSTRUCTIONS_LEDE =
  'MyWellfie reads your vitals from a short video of your face — no wearables, no lab visit. Just you, still and at rest, for less than a minute.';

export const ADHOC_INSTRUCTIONS_DURATION_LABEL = '35–60 second video selfie';

export const ADHOC_INSTRUCTIONS_STEPS: { num: string; title: string; body: string }[] = [
  {
    num: '01',
    title: 'Find good light',
    body: 'Face a window or lamp. Even, natural light gives the clearest reading.',
  },
  {
    num: '02',
    title: 'Stay still',
    body: 'Rest your phone or prop it up. Small movements can affect accuracy.',
  },
  {
    num: '03',
    title: "Don't talk",
    body: 'Keep a neutral, relaxed expression for the full recording.',
  },
  {
    num: '04',
    title: 'Breathe normally',
    body: 'No need to hold your breath — natural, resting breathing gives the best signal.',
  },
];

export const ADHOC_INSTRUCTIONS_FOOTNOTE =
  "MyWellfie's technology is calibrated to measure your indicators while you're at rest — the calmer and stiller you are, the more accurate your report.";

export const ADHOC_INSTRUCTIONS_CTA = "I'm ready";
